import React from 'react'

import Reflux from 'reflux-react-16'

import {Container} from './UI/index.js'
import {Button, Card, Colors, H3, P, S1, Row} from '../../src/components/UI/index.js'
import t from 'src/helpers/Languages.js'
import {formSpacing} from '../../src/components/UI/forms/index.js'

let pointsX = []
let pointsY = []

export default class Signature extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {
            signature: '',
            touched: false
        }

        this.drawLine = this.drawLine.bind(this)
        this.onResize = this.onResize.bind(this)
        this.onOrientationChange = this.onOrientationChange.bind(this)
        this.onTouchMove = this.onTouchMove.bind(this)
        this.onTouchEnd = this.onTouchEnd.bind(this)
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize)
        window.addEventListener('orientationchange', this.onOrientationChange)

        this.canvas.addEventListener('touchmove', this.onTouchMove, {passive: false})

        this.canvas.addEventListener('touchend', this.onTouchEnd, {passive: false})

        this.canvas.width = window.innerWidth
        this.canvas.height = window.innerHeight - 100
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize)
        window.removeEventListener('orientationchange', this.onOrientationChange)

        this.canvas.removeEventListener('touchmove', this.onTouchMove, {passive: false})

        this.canvas.removeEventListener('touchend', this.onTouchEnd, {passive: false})
    }

    drawLine() {
        const ctx = this.canvas.getContext('2d')

        if (pointsX.length > 0 && pointsY.length > 0) {
            ctx.beginPath()
            ctx.moveTo(pointsX[0], pointsY[0])
            for (let i = 1; i < pointsX.length; i += 3) {
                if (pointsX[i] && pointsY[i] && pointsX[i + 1] && pointsY[i + 1] && pointsX[i + 2] && pointsY[i + 2]) {
                    ctx.bezierCurveTo(pointsX[i], pointsY[i], pointsX[i + 1], pointsY[i + 1], pointsX[i + 2], pointsY[i + 2])
                }
            }
            ctx.stroke()
        }
    }

    onTouchMove(event) {
        event.preventDefault()

        if (event.touches) {
            if (event.touches.length == 1) { // Only deal with one finger
                const touch = event.touches[0] // Get the information for finger #1

                pointsX.push(touch.pageX - touch.target.offsetLeft)
                pointsY.push(touch.pageY - touch.target.offsetTop)
            }
        }

        this.drawLine()
    }

    onTouchEnd() {
        pointsX = []
        pointsY = []

        const {touched} = this.state

        if (!touched) {
            this.setState({touched: true})
        }
    }

    onResize() {
        const signature = this.canvas.toDataURL('image/png')

        setTimeout(() => {
            this.canvas.width = window.innerWidth
            this.canvas.height = window.innerHeight - 100

            const context = this.canvas.getContext('2d')
            const img = new Image()

            img.onload = () => {
                context.drawImage(img, 0, 0, img.width, img.height, 0, 0, this.canvas.width, this.canvas.height)
            }

            img.src = signature
        }, 100)
    }

    onOrientationChange() {
        const signature = this.canvas.toDataURL('image/png')

        setTimeout(() => {
            this.canvas.width = window.innerWidth
            this.canvas.height = window.innerHeight - 100

            const context = this.canvas.getContext('2d')
            const img = new Image()

            img.onload = () => {
                context.drawImage(img, 0, 0, img.width, img.height, 0, 0, this.canvas.width, this.canvas.height)
            }
            img.src = signature
        }, 100)
    }

    onClickClear() {
        const ctx = this.canvas.getContext('2d')
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.setState({touched: false})
    }

    onClickConfirm() {
        const {onConfirm} = this.props
        const signature = this.canvas.toDataURL('image/png')
        onConfirm(signature)
    }

    render() {
        const {order, address, colli, senderName, branding} = this.props
        const {touched} = this.state

        const deliveredColli = colli.filter((collo) => collo.status === 'delivered')
        const refusedColli = colli.filter((collo) => collo.status === 'refused')
        const notDeliveredColli = colli.filter((collo) => collo.status === 'missing' || collo.status === 'notdelivered')

        return (
            <Container style={{background: 'white'}}>
                <div style={{position: 'absolute', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                    <H3 style={{marginTop: 12, marginBottom: 24}}>{t('signature')}</H3>

                    <Card style={{marginBottom: 6, width: '90%'}}>
                        {address.name &&
                            <div style={{display: 'flex'}}>
                                <i style={{marginRight: 6, fontSize: 16, color: Colors.textMedium}} className={address.isBusiness || address.attention ? 'mdi mdi-store' : 'mdi mdi-account'} />
                                <S1 translate='no' disabled>{address.name}</S1>
                            </div>
                        }

                        {address.attention &&
                            <div style={{display: 'flex'}}>
                                <i style={{marginRight: 6, fontSize: 16, color: Colors.textMedium}} className='mdi mdi-account-outline' />
                                <S1 translate='no' disabled>{address.attention}</S1>
                            </div>
                        }

                        <P translate='no' disabled style={{marginLeft: 21}}>{`${address.street} ${address.nr}${address.addition}`}</P>
                        <P translate='no' disabled style={{marginLeft: 21}}>{address.street2}</P>
                        <P translate='no' disabled style={{marginLeft: 21, marginBottom: 12}}>{`${address.postalCode} ${address.city} (${address.country})`}</P>
                    </Card>

                    <Card style={{marginBottom: 6, width: '90%'}}>
                        <P disabled>
                            {`${t('consignor')}: `}<span translate='no'>{senderName || `${order.senderAddress?.name || order.customerAddress?.name}`}</span>
                        </P>
                    </Card>

                    {!!deliveredColli.length &&
                        <Card style={{marginBottom: 6, width: '90%'}}>
                            <P disabled>{`${t('delivered')}: (${deliveredColli.length}/${colli.length})`}</P>
                        </Card>
                    }

                    {!!refusedColli.length &&
                        <Card style={{marginBottom: 6, width: '90%'}}>
                            <P disabled>{`${t('refused')}: (${refusedColli.length}/${colli.length})`}</P>
                        </Card>
                    }

                    {!!notDeliveredColli.length &&
                        <Card style={{marginBottom: 6, width: '90%'}}>
                            <P disabled>{`${t('notDelivered')}: (${notDeliveredColli.length}/${colli.length})`}</P>
                        </Card>
                    }
                </div>

                <div style={{flex: 1, overflow: 'hidden'}}>
                    <canvas
                        style={{opacity: 0.8}}
                        ref={(ref) => this.canvas = ref}
                    />
                </div>

                <Row style={{flexShrink: 0, marginBottom: 6, paddingLeft: 6, paddingRight: 6, gap: formSpacing.tight, minWidth: 'auto'}}>
                    <Button
                        variant='solid'
                        style={{width: 120}}
                        size='xl'
                        icon='mdi mdi-refresh'
                        onClick={this.onClickClear.bind(this, '')}
                    />
                    <Button
                        variant='solid'
                        color={branding?.color || Colors.brandColor}
                        style={{width: '100%'}}
                        size='xl'
                        icon='mdi mdi-check'
                        disabled={!touched}
                        onClick={this.onClickConfirm.bind(this, '')}
                    />
                </Row>
            </Container>
        )
    }
}
